<template>
  <hi-sub-page>
    <hi-page-column card grow>
      Day
    </hi-page-column>
  </hi-sub-page>
</template>

<script>
import HiSubPage from "@/components/scaffold/HiSubPage";
import HiPageColumn from "@/components/scaffold/HiPageColumn";

export default {
  name: "Appointments_Day",
  components: { HiSubPage, HiPageColumn }
};
</script>

<style scoped></style>
